import { render } from "./BasicButton.vue?vue&type=template&id=06efc9b4&scoped=true&ts=true"
import script from "./BasicButton.vue?vue&type=script&lang=ts"
export * from "./BasicButton.vue?vue&type=script&lang=ts"

import "./BasicButton.vue?vue&type=style&index=0&id=06efc9b4&lang=scss&scoped=true"

import exportComponent from "/home/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06efc9b4"]])

export default __exports__